import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'wdx-app-header',
    templateUrl: './wdx-app-header.component.html',
    styleUrls: ['./wdx-app-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class WdxAppHeaderComponent {}
